import { render, staticRenderFns } from "./GalleryCredential.vue?vue&type=template&id=60bcce19&scoped=true&"
import script from "./GalleryCredential.vue?vue&type=script&lang=js&"
export * from "./GalleryCredential.vue?vue&type=script&lang=js&"
import style0 from "./GalleryCredential.vue?vue&type=style&index=0&id=60bcce19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bcce19",
  null
  
)

export default component.exports